// extracted by mini-css-extract-plugin
export default {"wrapper":"Od","form":"Pd","label":"Qd","asterisk":"Rd","smallprint":"Sd","noMargin":"Td","success":"Ud","circle":"Vd"};